<template>
  <div class="container">
    <h1>keycloakのユーザ登録用JSONファイルの生成</h1>
    <p>
      ユーザ登録用のCSVのダウンロードは<a
        href="/file/keycloakuser.csv"
        download="keycloakuser.csv"
        >こちら</a
      >
    </p>
    <div class="alert">
      <v-alert
        v-model="alert"
        border="start"
        variant="tonal"
        closable
        close-label=""
        color="red-accent-4"
        title="登録に失敗しました。"
      >
        {{ alertMsg }}
      </v-alert>
    </div>
    <div class="form">
      <v-file-input
        label="登録用ファイルの選択"
        accept="text/csv"
        v-model="inputFile"
      ></v-file-input>
      <v-btn
        class="btn1 bg-blue-lighten-1"
        @click="upload()"
        :loading="loading"
        :disabled="disabled"
        >アップロード</v-btn
      >
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      inputFile: [],
      loading: false,
      disabled: true,
      alert: false,
      alertMsg: "",
    };
  },
  watch: {
    inputFile() {
      if (this.inputFile.length == 0) {
        this.disabled = true;
      } else {
        this.disabled = false;
      }
    },
  },
  methods: {
    upload() {
      this.loading = true;
      axios
        .post(
          "https://api.dataplatform-yamanashi.jp/csv-convert",
          {
            data: this.inputFile,
          },
          {
            headers: {
              Authorization: "Bearer " + this.token,
              "content-type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          console.log(response);
          let data = response.data;
          data = JSON.stringify(data, null, 4);
          console.log(typeof data);
          const blob = new Blob([data], { type: "text/plain" });
          const url = URL.createObjectURL(blob);
          const a = document.createElement("a");
          document.body.appendChild(a);
          a.download = "keycloakuser.json";
          a.href = url;
          a.click();
          a.remove();
          URL.revokeObjectURL(url);
          this.loading = false;
          this.alert = false;
          this.inputFile = [];
        })
        .catch((error) => {
          console.log(error);
          this.alertMsg = error.response.data;
          this.loading = false;
          this.alert = true;
          this.inputFile = [];
        });
    },
  },
  computed: {
    token() {
      return this.$store.getters.token;
    },
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  margin: 36px 5%;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
}

.alert {
  width: 80%;
}

.form {
  width: 40%;
  margin-top: 32px;
}
</style>
